import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/vehicle_type_increase/statistics/',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/vehicle_type_increase/export',
    method: 'get',
    params,
  })
}
